import { useFeatureFlags, useLoggedInUser } from '@tcc/shared-data-lib';
import React from 'react';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';
import { Operation } from '../../hooks/useOperations/types';
import { importFromS3 } from '../../utils/importFromS3';
import {
  useFeatureFlagsConfigs,
  useUserLoggedInConfigs,
} from '../../utils/sharedData';

interface SeasonReportsPluginContainerProps {
  operations: Operation[];
  operationsSelected: string[];
}

const S3Plugin = React.lazy(() => importFromS3('tcc-season-reports-web'));
const MFPlugin = React.lazy(() => import('seasonReportsWeb/SeasonReportsWeb'));

export const SeasonReportsPluginContainer: React.FC<
  SeasonReportsPluginContainerProps
>
= ({ operations, operationsSelected }) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.seasonReports.module-federation'];

  const SeasonReportsPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  const { operation: impersonatedOperation } = useImpersonatedOperation();

  const operationIds = impersonatedOperation
    ? [impersonatedOperation.operationId]
    : operationsSelected;

  return (
    <SeasonReportsPlugin operations={operations} operationsSelected={operationIds} />
  );
};
